import {
    CONFIRM_EXTENSION_ADMIN_ROUTE,
    CONTROL_PANEL_BREAK_LOAN,
    CONTROL_PANEL_CAPTURE_GUARANTEE,
    CONTROL_PANEL_DETAIL_LOAN_ROUTE,
    CONTROL_PANEL_EXCESS_LOAN,
    CONTROL_PANEL_EXTENSION_LOAN,
    CONTROL_PANEL_GUARANTEE_REPLACEMENT,
    CONTROL_PANEL_MARGIN_CALL,
    CONTROL_PANEL_MOVE_TITLE_GUARANTEE,
    CONTROL_PANEL_NEW_LOAN,
    CONTROL_PANEL_RESTRICTION_GUARANTEE_SELECTION,
    CONTROL_PANEL_RETURN_MATURITY,
    CONTROL_PANEL_SETTLE_BREACH,
    CONTROL_PANEL_TRANSACTIONAL_LOG
} from "../../../utils/constants/RoutesConstants";
import {
    getUrlAgreeAndRefuseExcessLoan,
    getUrlAgreeAndRefuseExtensionLoan,
    getUrlAgreeAndRefuseGuaranteeReplacement,
    getUrlAgreeAndRefuseInitLoan,
    getUrlAgreeAndRefuseMarginCallLoan,
    getUrlAgreeAndRefuseMaturity
} from "./AgreeAndRefuseControlPanelUtil";
import {INCUMPLIMIENTO, INTERNO_STR, MARGIN_CALL, NOT_IN_FLOW} from "../../../utils/constants/Constants";

export function getUrlControlPanel(optionContextMenu, loan) {
    let url;
    switch (optionContextMenu) {
        case 'Continuar':
            url = getNextAction(loan);
            break;
        case 'Detalles':
            url = CONTROL_PANEL_DETAIL_LOAN_ROUTE;
            break;
        case 'Bitacora Transaccional':
            url = CONTROL_PANEL_TRANSACTIONAL_LOG;
            break;
        case 'Selección de Garantías':
            url = CONTROL_PANEL_RESTRICTION_GUARANTEE_SELECTION;
            break;
        case 'Incumplimiento':
            url = CONTROL_PANEL_BREAK_LOAN;
            break;
        case 'Regresar Vencimiento':
            url = CONTROL_PANEL_RETURN_MATURITY;
            break;
        case 'Sustitución':
            url = CONTROL_PANEL_GUARANTEE_REPLACEMENT;
            break;
        case 'Prórroga':
            url = CONTROL_PANEL_EXTENSION_LOAN;
            break;
        case 'Préstamo Nuevo':
            url = CONTROL_PANEL_NEW_LOAN;
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getNextAction(loan) {
    let institution = localStorage.getItem('institution');
    let status = loan['statusPV'];
    let url = '';
    if (validateContinue(loan, institution)) {
        switch (status) {
            case 'CG':
                url = CONTROL_PANEL_CAPTURE_GUARANTEE;
                break;
            case 'E':
                url = CONTROL_PANEL_EXCESS_LOAN;
                break;
            case 'LL':
                url = CONTROL_PANEL_MARGIN_CALL;
                break;
            case 'V':
            case 'VA':
            case 'TG':
            case 'CoTG':
            case 'RG':
            case 'CoRG':
            case 'TT':
            case 'CoTT':
            case 'RT':
            case 'CoRT':
            case 'TP':
            case 'CoTP':
                url = CONTROL_PANEL_MOVE_TITLE_GUARANTEE;
                break;
            case 'CoPr':
                url = CONFIRM_EXTENSION_ADMIN_ROUTE;
                break;
            case 'MG':
                url = CONTROL_PANEL_EXTENSION_LOAN;
                break;
            case 'I':
                url = CONTROL_PANEL_SETTLE_BREACH;
                break;
            default:
                url = '';
                break;
        }
    }
    return url;
}

export function validateContinue(loan, institution) {
    let isContinue = false;
    let status = loan['statusPV'];
    let lender = loan['nomCortoPTM'];
    let borrower = loan['nomCortoPTT'];
    let isAction = loan['isAction'];
    let isOtc = loan['otc'];

    if ((institution === 'Interno' &&
        (status === 'CoTG' || status === 'RG')) || (isOtc && lender === institution)) {
        isContinue = true;
    } else {
        if (lender === institution &&
            (
                status === 'TT' || status === 'CoRT' || status === 'CoPr' || status === 'CoTP'
            )) {
            isContinue = true;
        } else {
            if (borrower === institution &&
                (
                    status === 'TG'
                    || status === 'CoRG'
                    || status === 'V'
                    || status === 'VA'
                    || status === 'CG'
                    || status === 'LL'
                    || status === 'E'
                    || status === 'CoTT'
                    || status === 'RT'
                    || status === 'TP'
                    || status === 'MG'
                )) {
                isContinue = true;
            }
        }
    }
    if(institution === INTERNO_STR && status === INCUMPLIMIENTO) {
        isContinue = isAction = true
    }

    return isContinue && isAction;
}

export function getContextMenu(loan) {
    let institution = localStorage.getItem('institution');

    if (institution === 'Interno') {
        return getContextMenuAdmin(loan, institution);
    } else {
        return getContextMenuClient(loan, institution);
    }
}

export function getContextMenuAdmin(loan, institution) {
    let options = [];

    let loanFlow = loan['idFlujo'];
    let status = loan['statusPV'];

    if (validateContinue(loan, institution)) {
        options.push('Continuar');
    }
    options.push('Detalles');
    options.push('Bitacora Transaccional');
    if (status === 'V' || status === 'VA') {
        options.push('Regresar Vencimiento');
    }
    if (loanFlow === 0) {
        options.push('Vencimiento Anticipado');
    }
    options.push('Selección de Garantías');
    if ((status !== INCUMPLIMIENTO && loanFlow !== NOT_IN_FLOW)
        || (loanFlow === NOT_IN_FLOW && status === MARGIN_CALL)) {
        options.push('Incumplimiento');
    }

    if (loanFlow === 8 && status !== 'CoPr') {
        options.push('Préstamo Nuevo');
    }

    return options;
}

export function getContextMenuClient(loan, institution) {
    let options = [];

    let loanFlow = loan['idFlujo'];
    let borrower = loan['nomCortoPTT'];
    let status = loan['statusPV'];

    if (validateContinue(loan, institution)) {
        options.push('Continuar');
    }
    options.push('Detalles');
    if (borrower === institution && (status === 'V' || status === 'VA')) {
        options.push('Prórroga');
    }
    if (borrower === institution && loanFlow === 0) {
        options.push('Sustitución');
    }
    if (loanFlow === 8 && status !== 'CoPr') {
        options.push('Préstamo Nuevo');
    }
    options.push('Bitacora Transaccional');

    return options;

}

export function getReadOnlyReward(flowId, status) {
    let isReadOnly = undefined;

    if (flowId === 2) {
        switch (status) {
            case 'VA':
            case 'V':
            case 'RT':
                isReadOnly = false;
                break;
            case 'CoRT':
                isReadOnly = true;
                break;
            default:
                isReadOnly = undefined;
                break;
        }
    } else {
        if (flowId === 8) {
            switch (status) {
                case 'TP':
                    isReadOnly = false;
                    break;
                case 'CoTP':
                    isReadOnly = true;
                    break;
                default:
                    isReadOnly = undefined;
                    break;
            }
        }
    }


    return isReadOnly;
}

export function getReadOnlyTitles(status) {
    let isReadOnly;

    switch (status) {
        case 'V':
        case 'VA':
        case 'TT':
        case 'RT':
            isReadOnly = false;
            break;
        default:
            isReadOnly = true;
            break;
    }

    return isReadOnly;
}

export function getReadOnlyGuarantee(status) {
    let isReadOnly;

    switch (status) {
        case 'TG':
        case 'RG':
            isReadOnly = false;
            break;
        default:
            isReadOnly = true;
            break;
    }

    return isReadOnly;
}

export function getUrlAgreeAndReject(flowId, status, isReject) {
    let url;

    switch (flowId) {
        case 1:
            url = getUrlAgreeAndRefuseInitLoan(status, isReject);
            break;
        case 2:
            url = getUrlAgreeAndRefuseMaturity(status, isReject);
            break;
        case 3:
            url = getUrlAgreeAndRefuseExcessLoan(status, isReject);
            break;
        case 4:
            url = getUrlAgreeAndRefuseMarginCallLoan(status, isReject);
            break;
        case 7:
            url = getUrlAgreeAndRefuseGuaranteeReplacement(status, isReject);
            break;
        case 8:
            url = getUrlAgreeAndRefuseExtensionLoan(status, isReject);
            break;
        default:
            url = '';
            break;
    }

    return url;
}